module.exports = __webpack_public_path__ + "img/UZB.76e9f576.svg";